// Normalise un numéro pour wa.me / WhatsApp.
//
// Règles :
//  - retire espaces, points, tirets, parenthèses, "+"
//  - "00xxx" -> "xxx"
//  - numéro suisse commençant par "0" (10 chiffres) -> remplace le "0" initial par "41"
//  - Renvoie une chaîne ne contenant que des chiffres, ou "" si vide.
//
// Exemples :
//   0792312447       -> 41792312447
//   +41 79 231 24 47 -> 41792312447
//   0041792312447    -> 41792312447
//   079 231.24-47    -> 41792312447

export function normalizeWhatsApp(raw) {
  if (!raw) return "";
  // 1. ne garder que chiffres et "+"
  let s = String(raw).replace(/[^0-9+]/g, "");
  // 2. supprimer le "+"
  s = s.replace(/^\++/, "");
  // 3. "00..." -> ""
  if (s.startsWith("00")) s = s.slice(2);
  // 4. numéro suisse local "0XXXXXXXXX" (10 chiffres au total)
  //    -> remplace le "0" initial par "41"
  if (s.startsWith("0") && s.length === 10) s = "41" + s.slice(1);
  return s;
}

export function buildWhatsAppUrl(raw) {
  const n = normalizeWhatsApp(raw);
  return n ? `https://wa.me/${n}` : "";
}
